export function BrandStatement() {
  const statements = [
    "PREMIUM CRAFTED.",
    "TEXAS ROOTED.",
    "FAITH DRIVEN.",
  ];

  return (
    <section className="bg-background py-24 md:py-36">
      <div className="mx-auto max-w-[900px] px-6 text-center">
        <div className="flex flex-col items-center gap-1">
          {statements.map((s) => (
            <span
              key={s}
              className="font-heading text-3xl font-black italic leading-tight tracking-tight text-[#2A1510] sm:text-5xl md:text-6xl lg:text-7xl"
            >
              {s}
            </span>
          ))}
        </div>
        <p className="mx-auto mt-10 max-w-lg font-body text-sm leading-relaxed tracking-wide text-[#2A1510]/75 md:text-base">
          Premium sporting goods rooted in heritage and crafted without compromise.
        </p>
      </div>
    </section>
  );
}
